"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _withScopeId = function (n) { return (vue_2.pushScopeId("data-v-44c478da"), n = n(), vue_2.popScopeId(), n); };
var _hoisted_1 = {
    key: 0,
    class: "tui-call-kit",
    id: "tui-call-kit-id"
};
var _hoisted_2 = { class: "function-buttons" };
var Dialing_vue_1 = require("./Dialing.vue");
var ControlPanel_vue_1 = require("./ControlPanel.vue");
var Calling_Group_vue_1 = require("./Calling-Group.vue");
var Calling_C2CVideo_vue_1 = require("./Calling-C2CVideo.vue");
var store_1 = require("../store");
var constants_1 = require("../constants");
var index_1 = require("../index");
var minimize_vue_1 = require("../icons/minimize.vue");
var fullScreen_vue_1 = require("../icons/fullScreen.vue");
var interface_1 = require("../interface");
var vue_3 = require("vue");
exports.default = vue_1.defineComponent({
    __name: 'TUICallKit',
    props: {
        beforeCalling: {},
        afterCalling: {},
        onMinimized: {},
        onMessageSentByMe: {},
        allowedMinimized: { type: Boolean, default: false },
        allowedFullScreen: { type: Boolean, default: true },
        videoDisplayMode: { default: interface_1.VideoDisplayMode.COVER },
        videoResolution: { default: interface_1.VideoResolution.RESOLUTION_480P },
        lang: { default: "zh-cn" }
    },
    emits: ["kicked-out", "status-changed"],
    setup: function (__props, _a) {
        var emits = _a.emit;
        var props = __props;
        store_1.componentEmits.value = emits;
        var _b = vue_3.toRefs(props), beforeCalling = _b.beforeCalling, afterCalling = _b.afterCalling, onMinimized = _b.onMinimized, onMessageSentByMe = _b.onMessageSentByMe, allowedMinimized = _b.allowedMinimized, allowedFullScreen = _b.allowedFullScreen, videoDisplayMode = _b.videoDisplayMode, videoResolution = _b.videoResolution;
        vue_3.watchEffect(function () {
            index_1.TUICallKitServer.setCallback({
                beforeCalling: beforeCalling && beforeCalling.value,
                afterCalling: afterCalling && afterCalling.value,
                onMinimized: onMinimized && onMinimized.value,
                onMessageSentByMe: onMessageSentByMe && onMessageSentByMe.value,
            });
            store_1.currentDisplayMode.value = videoDisplayMode.value;
            store_1.currentVideoResolution.value = videoResolution.value;
        });
        function toggleMinimize() {
            if (document.fullscreenElement) {
                document.exitFullscreen();
            }
            index_1.TUICallKitServer.toggleMinimize();
        }
        function toggleFullscreen() {
            var elem = document.getElementById("tui-call-kit-id");
            if (!document.fullscreenElement) {
                elem.requestFullscreen().catch(function (err) {
                    alert("Error attempting to enable fullscreen mode: " + err.message + " (" + err.name + ")");
                });
            }
            else {
                document.exitFullscreen();
            }
        }
        return function (_ctx, _cache) {
            return (vue_2.unref(store_1.status) !== vue_2.unref(constants_1.STATUS).IDLE)
                ? vue_2.withDirectives((vue_2.openBlock(), vue_2.createElementBlock("div", _hoisted_1, [
                    vue_2.createElementVNode("div", _hoisted_2, [
                        (vue_2.unref(store_1.status) !== vue_2.unref(constants_1.STATUS).IDLE &&
                            vue_2.unref(allowedMinimized) === true &&
                            vue_2.unref(store_1.status) !== vue_2.unref(constants_1.STATUS).DIALING_C2C &&
                            vue_2.unref(store_1.status) !== vue_2.unref(constants_1.STATUS).DIALING_GROUP &&
                            vue_2.unref(store_1.status) !== vue_2.unref(constants_1.STATUS).BE_INVITED)
                            ? (vue_2.openBlock(), vue_2.createElementBlock("div", {
                                key: 0,
                                class: "minimize",
                                onClick: toggleMinimize
                            }, [
                                vue_2.createVNode(minimize_vue_1.default)
                            ]))
                            : vue_2.createCommentVNode("", true),
                        (vue_2.unref(allowedFullScreen) === true)
                            ? (vue_2.openBlock(), vue_2.createElementBlock("div", {
                                key: 1,
                                class: "minimize",
                                onClick: toggleFullscreen
                            }, [
                                vue_2.createVNode(fullScreen_vue_1.default)
                            ]))
                            : vue_2.createCommentVNode("", true)
                    ]),
                    (vue_2.unref(store_1.status) === vue_2.unref(constants_1.STATUS).BE_INVITED ||
                        vue_2.unref(store_1.status) === vue_2.unref(constants_1.STATUS).DIALING_C2C ||
                        vue_2.unref(store_1.status) === vue_2.unref(constants_1.STATUS).CALLING_C2C_AUDIO)
                        ? (vue_2.openBlock(), vue_2.createBlock(Dialing_vue_1.default, { key: 0 }))
                        : vue_2.createCommentVNode("", true),
                    (vue_2.unref(store_1.status) === vue_2.unref(constants_1.STATUS).CALLING_C2C_VIDEO)
                        ? (vue_2.openBlock(), vue_2.createBlock(Calling_C2CVideo_vue_1.default, { key: 1 }))
                        : vue_2.createCommentVNode("", true),
                    (vue_2.unref(store_1.status) === vue_2.unref(constants_1.STATUS).DIALING_GROUP ||
                        vue_2.unref(store_1.status) === vue_2.unref(constants_1.STATUS).CALLING_GROUP_AUDIO ||
                        vue_2.unref(store_1.status) === vue_2.unref(constants_1.STATUS).CALLING_GROUP_VIDEO)
                        ? (vue_2.openBlock(), vue_2.createBlock(Calling_Group_vue_1.default, { key: 2 }))
                        : vue_2.createCommentVNode("", true),
                    (vue_2.unref(store_1.status) !== vue_2.unref(constants_1.STATUS).IDLE)
                        ? (vue_2.openBlock(), vue_2.createBlock(ControlPanel_vue_1.default, { key: 3 }))
                        : vue_2.createCommentVNode("", true)
                ], 512)), [
                    [vue_2.vShow, !vue_2.unref(store_1.isMinimized)]
                ])
                : vue_2.createCommentVNode("", true);
        };
    }
});
